export default __webpack_public_path__ + "static/media/tracking-disabled.212bad26.png";